<section class="brand-profile-page">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <header class="brand-profile-page__header">
    <div>
      <h1>{{ pageTitle }}</h1>
      <p>Паспорт бренда, внутренние атрибуты и все видимые привязки к названиям.</p>
    </div>
  </header>

  <div class="brand-profile-layout">
    <section class="brand-card brand-card--passport">
      <div class="brand-card__header">
        <div>
          <h2>Паспорт бренда</h2>
          <p>Логотип, страна, рейтинг и основные параметры бренда.</p>
        </div>
      </div>

      <div class="brand-passport">
        <div class="brand-logo-panel">
          <div class="brand-logo-panel__preview" [class.brand-logo-panel__preview--empty]="!logoPreviewUrl">
            <img *ngIf="logoPreviewUrl; else emptyLogo" [src]="logoPreviewUrl" [alt]="brand?.description || 'Логотип бренда'" />
            <ng-template #emptyLogo>
              <div class="brand-logo-panel__placeholder">
                <mat-icon>image</mat-icon>
                <span>Логотип не загружен</span>
              </div>
            </ng-template>
          </div>

          <div class="brand-logo-panel__actions">
            <input
              #logoInput
              hidden
              type="file"
              accept="image/*"
              (change)="onLogoSelected($event)"
            />
            <button mat-stroked-button type="button" (click)="logoInput.click()" [disabled]="logoUploading">
              {{ logoUploading ? 'Загрузка...' : 'Загрузить логотип' }}
            </button>
            <button mat-button type="button" color="warn" (click)="clearLogo()" [disabled]="!logoName">
              Убрать логотип
            </button>
            <div class="brand-logo-panel__filename" *ngIf="logoName">{{ logoName }}</div>
          </div>
        </div>

        <form class="brand-form" [formGroup]="profileFormGroup" (ngSubmit)="save()">
          <mat-form-field appearance="outline">
            <mat-label>Наименование</mat-label>
            <input matInput type="text" placeholder="Наименование" formControlName="description" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Короткое название</mat-label>
            <input
              matInput
              type="text"
              placeholder="Короткое название"
              formControlName="short_description"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Страна производителя</mat-label>
            <input
              matInput
              type="text"
              formControlName="country"
              [matAutocomplete]="countryAutocomplete"
              placeholder="Выберите страну"
            />
            <mat-hint>Можно оставить пустым</mat-hint>
          </mat-form-field>

          <mat-autocomplete #countryAutocomplete="matAutocomplete">
            <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country">
              {{ country }}
            </mat-option>
          </mat-autocomplete>

          <div class="brand-rating">
            <div class="brand-rating__header">
              <div>
                <div class="brand-rating__title">Внутренний рейтинг</div>
                <div class="brand-rating__hint">Общая оценка бренда для менеджеров</div>
              </div>
              <button
                mat-button
                type="button"
                color="warn"
                (click)="clearRating()"
                [disabled]="!profileFormGroup.controls.rating.value"
              >
                Сбросить
              </button>
            </div>

            <div class="brand-rating__options">
              <button
                *ngFor="let rating of ratingOptions"
                mat-stroked-button
                type="button"
                class="brand-rating__option"
                [class.brand-rating__option--active]="isRatingActive(rating)"
                (click)="setRating(rating)"
              >
                <mat-icon>{{ isRatingActive(rating) ? 'star' : 'star_border' }}</mat-icon>
                <span>{{ rating }}</span>
              </button>
            </div>

            <div class="brand-rating__value" *ngIf="profileFormGroup.controls.rating.value as currentRating">
              {{ getRatingLabel(currentRating) }} ({{ currentRating }}/5)
            </div>
            <div class="brand-rating__value brand-rating__value--empty" *ngIf="!profileFormGroup.controls.rating.value">
              Рейтинг не задан
            </div>
          </div>

          <mat-checkbox formControlName="oe">OE</mat-checkbox>

          <div class="brand-form__actions">
            <button mat-flat-button type="submit" color="primary" [disabled]="loading || logoUploading">
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </section>

    <section class="brand-card brand-card--bindings">
      <div class="brand-card__header">
        <div>
          <h2>Привязки</h2>
          <p>Все названия текущего бренда и конфликты с другими брендами.</p>
        </div>
      </div>

      <div class="brand-bindings-section">
        <div class="brand-bindings-section__title">Названия бренда</div>

        <div class="brand-current-names" *ngIf="currentNames.length; else noCurrentNames">
          <div class="brand-current-name" *ngFor="let item of currentNames">
            <span class="brand-current-name__type">{{ getCurrentNameTypeLabel(item.type) }}</span>
            <span class="brand-current-name__value">{{ item.value }}</span>
          </div>
        </div>

        <ng-template #noCurrentNames>
          <div class="brand-empty-state">У бренда пока нет сохранённых названий.</div>
        </ng-template>

        <div class="brand-alias-manager">
          <app-description-list [brand]="brand" (brandChanged)="handleBrandChanged($event)"></app-description-list>
        </div>
      </div>

      <div class="brand-bindings-section">
        <div class="brand-bindings-section__title">Конфликтующие бренды</div>

        <div class="brand-empty-state" *ngIf="!conflicts.length">
          Конфликтующих брендов по текущим названиям не найдено.
        </div>

        <div class="brand-conflicts" *ngIf="conflicts.length">
          <article class="brand-conflict-card" *ngFor="let conflict of conflicts; trackBy: trackConflict">
            <div class="brand-conflict-card__head">
              <div>
                <a [routerLink]="['/brand', conflict.id]" class="brand-conflict-card__title">
                  #{{ conflict.id }} {{ conflict.description }}
                </a>
                <div class="brand-conflict-card__meta">
                  <span *ngIf="conflict.shortDescription">{{ conflict.shortDescription }}</span>
                  <span>Товаров: {{ conflict.productCount }}</span>
                </div>
              </div>
            </div>

            <div class="brand-conflict-card__label">Совпавшие названия</div>
            <div class="brand-conflict-card__names">
              <span class="brand-conflict-card__chip" *ngFor="let name of conflict.matchedNames">
                {{ name }}
              </span>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</section>
